module.exports = __webpack_public_path__ + "img/initial-status.c0255f7c.svg";